import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-dialog-scrollable modal-xl" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = { class: "col-sm-2 col-lg-2" }
const _hoisted_12 = { style: {"margin":"15px","text-align":"right"} }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "col-sm-10 col-lg-10" }
const _hoisted_15 = {
  class: "dashboard-box clearfix",
  style: {"padding":"15px 30px"}
}
const _hoisted_16 = {
  class: "pull-left",
  style: {"width":"50px"}
}
const _hoisted_17 = {
  class: "pull-left",
  style: {"width":"calc(100% - 50px)"}
}
const _hoisted_18 = { class: "small fg-color-gray1" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 0,
  style: {"overflow-x":"hidden"}
}
const _hoisted_21 = { class: "table table-striped" }
const _hoisted_22 = { style: {"overflow-x":"hidden"} }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = {
  key: 1,
  class: "fa fa-question-circle fg-color-gray"
}
const _hoisted_25 = { style: {"overflow-x":"hidden"} }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = {
  key: 1,
  class: "fa fa-question-circle fg-color-gray"
}

import { ref, computed, toRef } from 'vue'
    import moment from 'moment'

    import { dateCompare, tchMarked } from '@common/Common'

    import type { AlternativeLogEntryReadModel } from '@Alternatives/Alternatives/Domain/readmodels'
    import type { LogsBrowserViewModel } from '@Alternatives/Alternatives/Components/LogsBrowser'

    // ---------------- props ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'LogsBrowser',
  props: {
    viewModel: {}
  },
  setup(__props: any) {

    const props = __props

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- local state ----------------

    const logEntriesTitle = ref<string | null>(null)
    const searchLogEntriesPhrase = ref<string | null>(null)

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const initialized = computed(() => vm.value.initialized)

    const logEntriesView = computed<AlternativeLogEntryReadModel[]>(() =>
    {
        let view = [...vm.value.logs]

        if (logEntriesTitle.value)
        {
            const title = logEntriesTitle.value.toLowerCase()
            view = view.filter(a => a.Title?.toLowerCase() === title)
        }

        if (searchLogEntriesPhrase.value)
        {
            const phrase = searchLogEntriesPhrase.value.toLowerCase()
            view = view.filter(a =>
                (a.Person && a.Person.toLowerCase().includes(phrase)) ||
                (a.Description1 && a.Description1.toLowerCase().includes(phrase))
            )
        }

        return view
            .sort((a, b) =>
                dateCompare(new Date(a.Created), new Date(b.Created))
            )
            .reverse()
    })

    // ---------------- helpers ----------------

    function getHumanizedTimeSince(dateStr: string): string
    {
        const date = moment(dateStr)
        return moment
            .duration(moment().diff(date))
            .humanize()
            .replace(' ', '&nbsp;')
    }

    function formatDate(dateStr: string, format: string): string
    {
        return moment(dateStr).format(format)
    }

    function marked(str: string): string
    {
        return tchMarked(str)
    }

    // ---------------- actions ----------------

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "modal-title" }, "Browse logs", -1 /* CACHED */)),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                (!initialized.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Loading...", -1 /* CACHED */)
                    ]))]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _withDirectives(_createElementVNode("input", {
                            type: "search",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchLogEntriesPhrase).value = $event)),
                            class: "form-control",
                            placeholder: "Search log..."
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, searchLogEntriesPhrase.value]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((logEntriesTitle).value = $event)),
                            class: "form-control"
                          }, [...(_cache[4] || (_cache[4] = [
                            _createElementVNode("option", { value: null }, "All", -1 /* CACHED */),
                            _createElementVNode("option", { value: "Note added" }, "Notes", -1 /* CACHED */),
                            _createElementVNode("option", { value: "Email sent" }, "Emails", -1 /* CACHED */),
                            _createElementVNode("option", { value: "Dependency added" }, "Dependencies", -1 /* CACHED */),
                            _createElementVNode("option", { value: "Document added" }, "Documents", -1 /* CACHED */)
                          ]))], 512 /* NEED_PATCH */), [
                            [_vModelSelect, logEntriesTitle.value]
                          ])
                        ])
                      ]),
                      _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logEntriesView.value, (e) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "row",
                          key: e.Id
                        }, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("span", {
                                class: "fg-color-gray2 small",
                                innerHTML: getHumanizedTimeSince(e.Created)
                              }, null, 8 /* PROPS */, _hoisted_13),
                              _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "fg-color-gray2 small" }, "ago", -1 /* CACHED */))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(['fg-color-gray2', 'glyphicon', 'glyphicon-' + e.Icon]),
                                  style: {"font-size":"24px"}
                                }, null, 2 /* CLASS */)
                              ]),
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("strong", null, _toDisplayString(e.Title), 1 /* TEXT */),
                                _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                _createElementVNode("span", _hoisted_18, _toDisplayString(formatDate(e.Created, 'MMM Do, YYYY [at] hh:mm a')) + " by " + _toDisplayString(e.Person), 1 /* TEXT */),
                                _createElementVNode("p", {
                                  class: "log-content",
                                  innerHTML: marked(e.Description)
                                }, null, 8 /* PROPS */, _hoisted_19),
                                (e.Changes && e.Changes.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                      _createElementVNode("table", _hoisted_21, [
                                        _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
                                          _createElementVNode("tr", null, [
                                            _createElementVNode("th"),
                                            _createElementVNode("th", null, "Before"),
                                            _createElementVNode("th", null, "After")
                                          ])
                                        ], -1 /* CACHED */)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(e.Changes, (ch) => {
                                          return (_openBlock(), _createElementBlock("tbody", null, [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", null, _toDisplayString(ch.Property), 1 /* TEXT */),
                                              _createElementVNode("td", _hoisted_22, [
                                                (ch.PrevValue)
                                                  ? (_openBlock(), _createElementBlock("span", {
                                                      key: 0,
                                                      innerHTML: marked(ch.PrevValue)
                                                    }, null, 8 /* PROPS */, _hoisted_23))
                                                  : _createCommentVNode("v-if", true),
                                                (!ch.PrevValue)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_24))
                                                  : _createCommentVNode("v-if", true)
                                              ]),
                                              _createElementVNode("td", _hoisted_25, [
                                                (ch.CurrValue)
                                                  ? (_openBlock(), _createElementBlock("span", {
                                                      key: 0,
                                                      innerHTML: marked(ch.CurrValue)
                                                    }, null, 8 /* PROPS */, _hoisted_26))
                                                  : _createCommentVNode("v-if", true),
                                                (!ch.CurrValue)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_27))
                                                  : _createCommentVNode("v-if", true)
                                              ])
                                            ])
                                          ]))
                                        }), 256 /* UNKEYED_FRAGMENT */))
                                      ])
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ])
                            ])
                          ])
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Close")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})